// extracted by mini-css-extract-plugin
export default {"about-us":"About_about-us__d214b","about__img":"About_about__img__k++nF","about__wrapper":"About_about__wrapper__sqpeR","about__description":"About_about__description__qmxZB"};